import Vuetify from '../plugins/vuetify';
const $t = Vuetify.userPreset.lang.t;
import { parsePhoneNumber } from 'awesome-phonenumber';

export const last_name = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.last_name')
        ])
];
export const first_name = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.first_name')
        ])
];
export const email = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.email')
        ]),
    v =>
        /.+@.+\..+/.test(v) ||
        $t('$vuetify.validation_rules.valid', [$t('$vuetify.form_items.email')])
];

export const email_taxation_documentation = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.email_documentation_dispatch')
        ]),
    v =>
        /.+@.+\..+/.test(v) ||
        $t('$vuetify.validation_rules.valid', [
            $t('$vuetify.form_items.email_documentation_dispatch')
        ])
];
export const private_email = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.private_email')
        ]),
    v =>
        /.+@.+\..+/.test(v) ||
        $t('$vuetify.validation_rules.valid', [
            $t('$vuetify.form_items.private_email')
        ])
];
export const private_phone = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.private_phone')
        ]),
    v =>
        parsePhoneNumber(v).valid ||
        $t(
            '$vuetify.validation_rules.phone_number',
            $t('$vuetify.form_items.private_phone')
        )
];
export const business_email = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.business_email')
        ]),
    v =>
        /.+@.+\..+/.test(v) ||
        $t('$vuetify.validation_rules.valid', [
            $t('$vuetify.form_items.business_email')
        ])
];
export const business_phone = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.business_phone')
        ]),
    v =>
        parsePhoneNumber(v).valid ||
        $t(
            '$vuetify.validation_rules.business_phone',
            $t('$vuetify.form_items.business_phone')
        )
];
export const company_id = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.company_id')
        ])
];
export const zip_code = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.zip_code')
        ])
];
export const password = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.password')
        ]),
    v => (v && v.length >= 8) || $t('$vuetify.validation_rules.min_chars', [8])
];
export const password_confirmation = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.password_confirmation')
        ]),
    v => (v && v.length >= 8) || $t('$vuetify.validation_rules.min_chars', [8])
];
export const terms_and_conditions = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.terms_and_conditions')
        ])
];
export const employment_type = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.employment_type')
        ])
];
export const street = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.street')
        ])
];
export const street_number = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.street_number')
        ])
];
export const city = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.city')
        ])
];
export const country = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.country')
        ])
];
export const birth_date = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.birth_date')
        ])
];
export const salutation = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.salutation')
        ])
];
export const avatar = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.avatar')
        ])
];
export const subject = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.subject')
        ])
];
export const reason = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.subject')
        ])
];
export const message = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.message')
        ])
];
export const topic = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.topic')
        ])
];
export const new_retailer_number = [
    v =>
        !!v ||
        $t('$vuetify.validation_rules.required', [
            $t('$vuetify.form_items.new_retailer_number')
        ])
];
